import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCrop: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCrop"><Path d="M2.5 5.5H18.5V21.5M5.50009 2.5V18.5H21.5001" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCrop;
